import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const CustomUsersApi = createApi({
  reducerPath: "CustomUsersApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSpecificCustomUser: builder.query({
      query: () => `/vehicles/users/vehicles`,
    }),
  }),
});

export const { useGetSpecificCustomUserQuery } = CustomUsersApi;
